/**
 * Homepage Scroll Reveal & Animations
 * Handles IntersectionObserver-based scroll reveals for all hp-reveal elements
 */
(function() {
  'use strict';

  function initScrollReveal() {
    var revealElements = document.querySelectorAll('.hp-reveal, .hp-reveal--scale, .hp-reveal--left, .hp-reveal--right');
    if (!revealElements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    revealElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Also reinit on Shopify section load (theme editor support)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initScrollReveal, 100);
  });
})();
